export default __webpack_public_path__ + "static/media/typeL_low.e88bf4fb.png";